import { connect } from 'react-redux'
import AnnouncementsPanel from './AnnouncementsPanel'
import { AnnouncementsPanelProps } from './types'
import { State } from '../../dataStore/reducers/reducerType'
import { setAudienceMessage, clearAudienceMessage } from '../../dataStore/slices/messaging/messagingSlice'

type Dispatch = 'onSubmit' | 'onClear'

const mapStateToProps = (state: State): Omit<AnnouncementsPanelProps, Dispatch> => ({
  roomname: state.config.roomname || '',
  audienceMessage: state.messaging.message,
  disabled: state.messaging.isDisabled
})

const mapDispatchToProps = (dispatch): Pick<AnnouncementsPanelProps, Dispatch> => ({
  onSubmit: (roomname, message) => dispatch(setAudienceMessage({ roomname, message })),
  onClear: (roomname) => dispatch(clearAudienceMessage(roomname))
})

export default connect(mapStateToProps, mapDispatchToProps)(AnnouncementsPanel)
